import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { importProvidersFrom } from '@angular/core';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { tokenInterceptor } from './core/interceptors/token.interceptor';
import { routes } from './app.routes';
import { provideAnimations } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import { DialogModule } from '@angular/cdk/dialog';
import { provideLottieOptions } from 'ngx-lottie';
import player from 'lottie-web';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }), 
    provideRouter(routes),
    provideHttpClient(
      withInterceptors([tokenInterceptor])
    ),
    importProvidersFrom(
      AngularSvgIconModule.forRoot()
    ),
    provideAnimations(),
    importProvidersFrom(
      DialogModule
    ),
    importProvidersFrom(
      ToastrModule.forRoot({
        timeOut: 4000,
        positionClass: 'toast-top-right',
        preventDuplicates: true,
        closeButton: true,
        progressBar: true,
        enableHtml: true,
        newestOnTop: true,
        tapToDismiss: true,
        easeTime: 300,
        extendedTimeOut: 1000
      })
    ),
    provideLottieOptions({
      player: () => player,
    }),
  ]
};
